import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { Calendar, ArrowLeft } from 'lucide-react';
import { Breadcrumb, breadcrumbJsonLd } from '../../components/Breadcrumb';

export default function BlogDetailPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getBlogPost(slug)
      .then(r => setPost(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[hsl(221,83%,22%)]"></div></div>;
  if (!post) return <div className="min-h-screen flex flex-col items-center justify-center"><h1 className="text-2xl font-semibold mb-4">Yazi bulunamadi</h1><Link to="/blog" className="text-[hsl(221,83%,22%)] underline">Blog'a don</Link></div>;

  const blogBreadcrumb = [
    { label: 'Ana Sayfa', href: '/' },
    { label: 'Blog', href: '/blog' },
    { label: post.title, href: `/blog/${slug}` }
  ];

  return (
    <>
      <Helmet>
        <title>{post.seo_title || post.title || 'Blog'}</title>
        <meta name="description" content={post.seo_description || ''} />
        <meta property="og:title" content={post.seo_title || post.title} />
        <meta property="og:description" content={post.seo_description || ''} />
        <meta property="og:type" content="article" />
        {post.cover_image && <meta property="og:image" content={post.cover_image} />}
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": post.title,
          "datePublished": post.created_at,
          "dateModified": post.updated_at || post.created_at
        })}</script>
        <script type="application/ld+json">{breadcrumbJsonLd(blogBreadcrumb)}</script>
      </Helmet>

      <article className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-6">
            <Breadcrumb items={blogBreadcrumb} />
          </div>
          {post.cover_image && (
            <img src={post.cover_image} alt={post.title} className="w-full h-64 sm:h-96 object-cover rounded-xl mb-8" />
          )}
          <h1 className="text-3xl sm:text-4xl font-semibold mb-4" data-testid="blog-detail-title">{post.title}</h1>
          <div className="flex items-center gap-2 text-sm text-muted-foreground mb-8">
            <Calendar className="h-4 w-4" />
            {new Date(post.created_at).toLocaleDateString('tr-TR')}
          </div>
          <div className="prose prose-slate max-w-none" dangerouslySetInnerHTML={{ __html: post.content }} />
        </div>
      </article>
    </>
  );
}
